import { Component, OnInit } from '@angular/core';
import { UserLoginModel } from '../../models/user.model'
import { AuthService } from '../../services/auth.service'
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { UsersRequestPasswordResetComponent } from '../shared/dialogs/users-request-password-reset/users-request-password-reset.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  user: UserLoginModel = new UserLoginModel();
  hide = true;
  rememberme = false;
  
  constructor(
    private auth: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    // Recovery takes precedence over any previously authenticated account.
    if (this.route.snapshot.queryParamMap.has('rp')) {
      this.loginPasswordReset(this.route.snapshot.queryParamMap.get('rp') || '');
      return;
    }
    if (this.auth.isAuthenticated())
      this.router.navigateByUrl('/admin/dashboard');

    if ( localStorage.getItem('email') ) {
      this.user.email = localStorage.getItem('email')!;
      this.rememberme = true;
    }
  }

  blockEnter =  false;

  private async loginPasswordReset(rp: string): Promise<void> {
    this.blockEnter = true;
    this.auth.logout();
    // Remove the single-use token from the current browser history entry.
    await this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { rp: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
    Swal.fire({
      icon: 'info',
      title: 'Validando enlace...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });
    this.auth.loginPasswordReset(rp).subscribe({
      next: () => {
        Swal.close();
        // AuthGuard opens the existing mandatory password-change dialog.
        this.router.navigateByUrl('/admin/dashboard', { replaceUrl: true });
      },
      error: err => {
        this.blockEnter = false;
        Swal.fire({
          icon: 'error',
          title: 'No se pudo recuperar la contraseña',
          text: err.status === 400
            ? 'El enlace es inválido, ya fue utilizado, expiró o no permite acceder a esta cuenta. Solicite un nuevo enlace de recuperación.'
            : 'No fue posible completar el acceso. Solicite un nuevo enlace de recuperación e intente nuevamente.',
          heightAuto: false
        });
      }
    });
  }

  login(form: NgForm) {

    if (form.invalid) { return; }
    if(this.blockEnter) { return; }
    this.user.email = this.user.email.trim();

    Swal.fire({
      icon: 'info',
      title: 'Espere...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.blockEnter = true;
    this.auth.login(this.user).subscribe(resp => {
      if (this.rememberme) {
        localStorage.setItem('email', this.user.email);
      }
      Swal.close();
      this.router.navigateByUrl('admin/dashboard');
    }, (err) => {
      console.log(err.error.message, err.error.data);
      const data =  err.error.blocked? {blocked : false} : err.error.data;
       this.blockEnter = false;
      Swal.fire({
        icon: 'error',
        title: 'Error al autenticar',
        text: data && data.blocked ? 'Máximo de intentos fallidos excedido, contacte a Búho para más información.' :  'Usuario o contraseña no válido' 
      }); 
    });
  }

  openDialog() {
    if (this.blockEnter) { return; }
    this.dialog.open(UsersRequestPasswordResetComponent, {
      width: '480px',
      maxWidth: '95vw'
    });
  }

}
